export const fetchUser = () => {
  return localStorage.getItem("user") !== "undefined"
    ? JSON.parse(localStorage.getItem("user") || "")
    : localStorage.clear();
};
export const checkUserConnexion = () => {
  if (localStorage.getItem("user") === null) {
    return false;
  }
  return true;
};
